/* eslint-disable prefer-rest-params */

import { getPage, getShop, isInaEss } from './common/pageData';
import { getIsDPSEnabled } from './common/settings';
import { sleep } from './common/time';
import { logger } from './common/logger';
import { requestForPdpFgUsingStoredData } from './freegift';
import { filterWidgets } from './features/commonModuleForEmbeddedAndAutoAdd';

const interceptionPaths = [
  '/cart/change.js',
  '/cart/add.js',
  '/cart/update.js',
  '/cart/change',
  '/cart/add',
  '/cart/update',
];

const getSkipPathsForSpecificStores = () => {
  if (getShop() === 'refybeauty.myshopify.com') {
    return ['/cart/update.js'];
  }

  if (getShop() === 'bkind-products.myshopify.com') {
    return ['/cart/change.js', '/cart/change', '/cart/add'];
  }

  // skipping this as listener is always executed
  if (
    [
      'brigantes-consulting-ltd.myshopify.com',
      'murdycreativeco.myshopify.com',
    ].includes(getShop())
  ) {
    return [
      '/cart/change.js',
      '/cart/change',
      '/cart/add',
      '/cart/add.js',
      '/cart/update.js',
      '/cart/update',
    ];
  }

  return [];
};

const isSkipSpecificParams = ({ params }) => {
  if (getShop() === 'mygeisha-ro.myshopify.com') {
    return params.get('custom') === '1';
  }

  return false;
};

const cartRefreshMatch = ({ fullURL, params, urlPath, cartListenerConfig }) => {
  if (
    urlPath.endsWith('/cart') ||
    urlPath.endsWith('/cart/') ||
    urlPath.endsWith('/recommendations/products')
  ) {
    if (getShop() === 'elizabeth-scarlett.myshopify.com') {
      return params.get('view') === 'cartitems';
    }

    if (
      [
        'gb-gifts-app-monk-cross.myshopify.com',
        'quemdisseberenicept.myshopify.com',
        'boti-colombia.myshopify.com',
        'o-boticario-pt.myshopify.com',
      ].includes(getShop()) &&
      urlPath.endsWith('/recommendations/products')
    ) {
      return false;
    }

    if (params.get('view') === 'ajax') {
      return true;
    }

    if (params.get('view') === 'ajaxcart') {
      return true;
    }

    if (params.get('view') === 'drawer') {
      return true;
    }

    // for ina ess a custom event is already triggered
    if (params.get('section_id') === 'mini-cart' && !isInaEss()) {
      return true;
    }
  }

  if (getShop() === 'suprfit-fitness-equipment.myshopify.com') {
    if (urlPath.endsWith('.header-items')) {
      return true;
    }

    if (fullURL && fullURL.includes('.header-items')) {
      return true;
    }
  }

  const sectionsData = params.get('sections');
  if (sectionsData && sectionsData.includes('cart-drawer')) {
    return true;
  }

  if (sectionsData && sectionsData.includes('cart-item-container')) {
    return true;
  }

  if (sectionsData && sectionsData.includes('main-cart')) {
    return true;
  }

  if (getShop() === 'knya-med.myshopify.com') {
    const id = params.get('id');
    if (id && id === 'CartDrawer') {
      return true;
    }
  }

  if (params.get('section_id') === 'cart-drawer') {
    return true;
  }

  if (params.get('section_id') === 'cart-template') {
    return true;
  }

  if (params.get('section_id') === 'api-cart-items') {
    return true;
  }

  if (params.get('section_id') === 'main-cart-items') {
    return true;
  }

  if (params.get('view') === 'ajax_side_cart') {
    return true;
  }

  const sectionID = params.get('section_id');
  if (
    sectionID &&
    sectionID.includes('cart-drawer') &&
    [
      'refybeauty.myshopify.com',
      'h-activa.myshopify.com',
      'vonabride.myshopify.com',
    ].includes(getShop())
  ) {
    return true;
  }

  const sections = params.get('sections');
  if (sections && sections.includes('mini_cart')) {
    return true;
  }

  const {
    cartListenerValue,
    cartListenerKey,
    cartListenerCondition,
  } = cartListenerConfig;

  if (
    cartListenerValue !== '' &&
    cartListenerKey !== '' &&
    cartListenerCondition
  ) {
    const value = params.get(cartListenerKey);
    logger.log('cart listener', value);
    if (value && cartListenerCondition === 'equal_to') {
      return value === cartListenerValue;
    }
    if (value && cartListenerCondition === 'contains') {
      return value.includes(cartListenerValue);
    }
  }

  return false;
};

export function registerHTTPInterceptor({
  cartPageDiscountConfig,
  isDiscountCodeEnabled,
  isCVBEnabled,
  isSubscriptionUpsellEnabled,
  isShopifyFunctionsEnabled,
  isEmbeddedEnabled,
  isAutoFreegiftEnabled,
  isShipProEnabled,
  widgets,
  cartListenerConfig,
}) {
  registerInterceptors({
    cartPageDiscountConfig,
    isDiscountCodeEnabled,
    isCVBEnabled,
    isSubscriptionUpsellEnabled,
    isShopifyFunctionsEnabled,
    isEmbeddedEnabled,
    isAutoFreegiftEnabled,
    isShipProEnabled,
    widgets,
    cartListenerConfig,
  });
  logger.log('registered mri');
}

function registerInterceptors({
  cartPageDiscountConfig,
  isDiscountCodeEnabled,
  isCVBEnabled,
  isSubscriptionUpsellEnabled,
  isShopifyFunctionsEnabled,
  isEmbeddedEnabled,
  isAutoFreegiftEnabled,
  isShipProEnabled,
  widgets,
  cartListenerConfig,
}) {
  // eslint-disable-next-line prefer-destructuring
  const open = window.XMLHttpRequest.prototype.open;

  // ********** IMPORTANT *************/
  // don't change function to arrow function () => as it will break store XHR requests

  // eslint-disable-next-line func-names
  window.XMLHttpRequest.prototype.open = function() {
    this.addEventListener(
      'loadend',
      () => {
        onIntercept({
          cartPageDiscountConfig,
          isDiscountCodeEnabled,
          url: this.responseURL,
          isCVBEnabled,
          isSubscriptionUpsellEnabled,
          isShopifyFunctionsEnabled,
          isEmbeddedEnabled,
          isAutoFreegiftEnabled,
          isShipProEnabled,
          widgets,
          cartListenerConfig,
        });
      },
      false,
    );
    open.apply(this, arguments);
  };

  const { fetch: originalFetch } = window;

  // ********** IMPORTANT *************/
  // don't change function to arrow function () => as it will break store fetch requests

  // eslint-disable-next-line func-names
  window.fetch = function() {
    const t = originalFetch.apply(this, arguments);
    t.then(response => {
      if (response.ok) {
        onIntercept({
          cartPageDiscountConfig,
          isDiscountCodeEnabled,
          url: response.url,
          isCVBEnabled,
          isSubscriptionUpsellEnabled,
          isShopifyFunctionsEnabled,
          isEmbeddedEnabled,
          isAutoFreegiftEnabled,
          isShipProEnabled,
          widgets,
          cartListenerConfig,
        });
      }
    });
    return t;
  };

  // this event is supposed to be triggered after the ajax cart is successfully updated
  document.documentElement.addEventListener('mr:ajaxCartUpdated', () => {
    // TODO: call the functions needed separately, currently we are calling the api intercept function
    // as if liquid template is being used to update cart
    logger.log('custom cart updated trigger called');
    onIntercept({
      cartPageDiscountConfig,
      isDiscountCodeEnabled,
      url: `${window.location.origin}/cart?view=ajax`,
      isCVBEnabled,
      isSubscriptionUpsellEnabled,
      isShopifyFunctionsEnabled,
      isEmbeddedEnabled,
      isAutoFreegiftEnabled,
      isShipProEnabled,
      widgets,
      cartListenerConfig,
    });
  });

  if (['jenessawaitshop.myshopify.com'].includes(getShop())) {
    document.addEventListener('cart:updated', () => {
      // TODO: call the functions needed separately, currently we are calling the api intercept function
      // as if liquid template is being used to update cart
      logger.log('custom cart updated trigger called');
      onIntercept({
        cartPageDiscountConfig,
        isDiscountCodeEnabled,
        url: `${window.location.origin}/cart?view=ajax`,
        isCVBEnabled,
        isSubscriptionUpsellEnabled,
        isShopifyFunctionsEnabled,
        isEmbeddedEnabled,
        isAutoFreegiftEnabled,
        isShipProEnabled,
        widgets,
        cartListenerConfig,
      });
    });
  }
}

async function onIntercept({
  cartPageDiscountConfig,
  isDiscountCodeEnabled,
  url,
  isCVBEnabled,
  isSubscriptionUpsellEnabled,
  isShopifyFunctionsEnabled,
  isEmbeddedEnabled,
  isAutoFreegiftEnabled,
  isShipProEnabled,
  widgets,
  cartListenerConfig,
}) {
  const { path: urlPath, params } = getPathAndParamsFromURI(url);
  try {
    let matched = interceptionPaths.some(path => urlPath.endsWith(path));
    const specificSkipPaths = getSkipPathsForSpecificStores();
    if (matched && specificSkipPaths.some(path => urlPath.endsWith(path))) {
      matched = false;
    }

    if (matched && isSkipSpecificParams({ params })) {
      matched = false;
    }

    const isInternal = params.get('mr') === '1';
    const isSkip = params.get('mrs') === '1';
    if (!matched) {
      matched = cartRefreshMatch({
        fullURL: url,
        params,
        urlPath,
        cartListenerConfig,
      });
    }

    const cartDiscountModule = await import('./cartDiscount');
    // for any cart changes done by other sources apart from us
    // check both free gift offer and cart value bar
    if (matched && !isInternal) {
      const checkOffers = async () => {
        await sleep(300);

        if (isAutoFreegiftEnabled || isEmbeddedEnabled) {
          if (isEmbeddedEnabled) {
            const embeddedModule = await import('./features/embeddedModule');
            await embeddedModule.checkEmbeddedCartAndCheckoutPageWidgets({
              widgets,
              cartPageDiscountConfig,
              isDiscountCodeEnabled,
            });
          }

          if (isAutoFreegiftEnabled) {
            const autoAddFreegiftModule = await import('./features/autoAddFreegift');
            const filteredWidgets = filterWidgets({
              offerTypes: ['freegift'],
              displayType: 'embedded',
              widgets,
              availingType: 'auto_add',
              triggerTypes: ['cart_page', 'checkout_page'],
            });
            if (filteredWidgets.length > 0) {
              await autoAddFreegiftModule.checkFGAutoAddCartAndCheckoutPageOffer(
                {
                  widgets: filteredWidgets,
                  cartPageDiscountConfig,
                  isDiscountCodeEnabled,
                },
              );
            }
          }

          const isCartPage = getPage() === 'cart';

          // if there is pdp fg data present in storage, it meeans that pdp fg offer had become eligible in the same session.
          // in that case, we have to send an offer request when a change happens in cart. this is done because if the primary product has been removed, we'll need to auto remove the fg
          await requestForPdpFgUsingStoredData({
            cartPageDiscountConfig,
            isDiscountCodeEnabled,
            isCalledFromCartDrawer: !isCartPage,
          });
        }

        if (isCVBEnabled) {
          const cvbModule = await import('./features/cvbModule');
          await cvbModule.checkCVBAndDisplay({
            retryContainerCreation: true,
            cartPageDiscountConfig,
            isDiscountCodeEnabled,

            widgets,
          });
        }

        logger.log(
          'subscription check 2',
          isSubscriptionUpsellEnabled,
          isShopifyFunctionsEnabled,
        );
        if (isSubscriptionUpsellEnabled && isShopifyFunctionsEnabled) {
          const subscriptionUpsellModule = await import('./features/subscriptionUpsellModule');
          subscriptionUpsellModule.checkSubscriptionUpsellAndDisplay({
            widgets,
          });
        }

        if (getIsDPSEnabled()) {
          const dpsModule = await import('./features/dpsModule');
          dpsModule.checkOffer({});
        }

        if (isShipProEnabled) {
          const shipProModule = await import('./features/shipProModule');
          shipProModule.checkShippingProtectionAndDisplay({
            cartPageDiscountConfig,
            isDiscountCodeEnabled,
            widgets,
          });
        }

        cartDiscountModule.checkAndUpdateCartDiscount({
          cartPageDiscountConfig,
          isDiscountCodeEnabled,
        });
      };

      checkOffers();
    }

    // for any internal cart changes check cvb offers and cart discount
    if (matched && isInternal && !isSkip) {
      const check = async () => {
        if (isCVBEnabled) {
          const cvbModule = await import('./features/cvbModule');
          await cvbModule.checkCVBAndDisplay({
            retryContainerCreation: true,
            cartPageDiscountConfig,
            isDiscountCodeEnabled,

            widgets,
          });
        }

        logger.log(
          'subscription check',
          isSubscriptionUpsellEnabled,
          isShopifyFunctionsEnabled,
        );
        if (isSubscriptionUpsellEnabled && isShopifyFunctionsEnabled) {
          logger.log('subscription check');
          const subscriptionUpsellModule = await import('./features/subscriptionUpsellModule');
          subscriptionUpsellModule.checkSubscriptionUpsellAndDisplay({
            widgets,
          });
        }

        if (getIsDPSEnabled()) {
          const dpsModule = await import('./features/dpsModule');
          dpsModule.checkOffer({});
        }

        if (isShipProEnabled) {
          const shipProModule = await import('./features/shipProModule');
          shipProModule.checkShippingProtectionAndDisplay({
            cartPageDiscountConfig,
            isDiscountCodeEnabled,
            widgets,
          });
        }

        if (getShop() === 'raevoluz.myshopify.com') {
          if (isEmbeddedEnabled) {
            const embeddedModule = await import('./features/embeddedModule');
            await sleep(2000);
            embeddedModule.checkEmbeddedCartAndCheckoutPageWidgets({
              widgets,
              cartPageDiscountConfig,
              isDiscountCodeEnabled,
            });
          }
        }
        if (getShop() === 'raevoluz.myshopify.com') {
          if (isAutoFreegiftEnabled) {
            const autoAddFreegiftModule = await import('./features/autoAddFreegift');
            await sleep(2000);
            const filteredWidgets = filterWidgets({
              offerTypes: ['freegift'],
              displayType: 'embedded',
              widgets,
              availingType: 'auto_add',
              triggerTypes: ['cart_page', 'checkout_page'],
            });
            if (filteredWidgets.length > 0) {
              autoAddFreegiftModule.checkFGAutoAddCartAndCheckoutPageOffer({
                widgets: filteredWidgets,
                cartPageDiscountConfig,
                isDiscountCodeEnabled,
              });
            }
          }
        }

        cartDiscountModule.checkAndUpdateCartDiscount({
          cartPageDiscountConfig,
          isDiscountCodeEnabled,
        });
      };
      check();
    }
  } catch (e) {
    logger.log('error in intercept', e);
  }
}

const getPathAndParamsFromURI = uri => {
  const parts = uri.split('?');
  if (parts.length < 2) {
    return { path: parts[0], params: new URLSearchParams('') };
  }

  // Return parameters
  return { path: parts[0], params: new URLSearchParams(parts[1]) };
};
